// extracted by mini-css-extract-plugin
export default {"container":"blogCategories_container__qhtbc","top":"blogCategories_top__u1J0k","bottom":"blogCategories_bottom__-pPrW"};